import { render, staticRenderFns } from "./ColdWater.vue?vue&type=template&id=6b6a4ceb&scoped=true&"
import script from "./ColdWater.vue?vue&type=script&lang=ts&"
export * from "./ColdWater.vue?vue&type=script&lang=ts&"
import style0 from "./ColdWater.vue?vue&type=style&index=0&id=6b6a4ceb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a4ceb",
  null
  
)

export default component.exports